import React, { useState } from "react";
import {
  Button,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  CircularProgress,
  IconButton,
  Box,
  Typography,
} from "@mui/material";
import axiosInterceptorInstance from "../../../utils/axios.interceptor";
import CloseIcon from "@mui/icons-material/Close";
import { motion } from "framer-motion";
import { toast } from "react-toastify";

const SimDispatch = () => {
  const [selectedFile, setSelectedFile] = useState<any>(null);
  const [action, setAction] = useState(false);
  const [open, setOpen] = useState(false);

  const handleFileChange = (event: any) => {
    const file = event.target.files?.[0] || null;
    setSelectedFile(file);
  };

  const handleUploadFile = () => {
    toast.dismiss();
    if (!selectedFile) {
      toast.error("Please select a file first.");
    } else {
      setOpen(true);
    }
  };

  const uploadFile = async () => {
    toast.dismiss();
    setAction(true);
    const formData = new FormData();
    formData.append("file", selectedFile);

    try {
      const response = await axiosInterceptorInstance.post(
        "/dashboard/UpdateDispatchSim",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      toast.info(response.data.message);
    } catch (error) {
      console.error("Upload failed:", error);
      toast.error("File upload failed.");
    } finally {
      setAction(false);
      setOpen(false);
      setSelectedFile(null);
    }
  };

  const handleRemoveFile = () => {
    setSelectedFile(null);
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ ease: "linear", duration: 0.5 }}
    >
      <div className="boxShadow">
        <h2 className="sectionTitle">Sim Dispatch</h2>
        <div className="boxInner">
          <Grid container spacing={2}>
            <Grid item xs={8}>
              <Button
                style={{ width: "300px" }}
                variant="contained"
                component="label"
              >
                Choose File
                <input
                  key={selectedFile ? selectedFile.name : "file-input"}
                  type="file"
                  hidden
                  onChange={handleFileChange}
                  accept=".xlsx,.csv"
                />
              </Button>
              {selectedFile && (
                <Box display="flex" alignItems="center" mt={2}>
                  <Typography variant="body1">{selectedFile.name}</Typography>
                  <IconButton
                    onClick={handleRemoveFile}
                    size="small"
                    sx={{ ml: 1 }}
                  >
                    <CloseIcon />
                  </IconButton>
                </Box>
              )}
            </Grid>
            <Grid item xs={4}>
              <Button
                onClick={handleUploadFile}
                className="dButton dButton2"
                variant="contained"
              >
                Upload File
              </Button>
            </Grid>
          </Grid>
        </div>
      </div>

      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle>File Upload Confirmation</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Would you really like to upload this file?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            className="dButton dButton2 dbuttonSec"
            onClick={() => setOpen(false)}
          >
            No
          </Button>
          <Button
            variant="contained"
            className="dButton dButton2"
            onClick={uploadFile}
            disabled={action}
            autoFocus
          >
            {action ? <CircularProgress color="inherit" size={24} /> : "Yes"}
          </Button>
        </DialogActions>
      </Dialog>
    </motion.div>
  );
};

export default SimDispatch;
